module.exports = __webpack_public_path__ + "media/images/trello-fc133f30b86d70f08e9238997ac25efa.png";